import { createTheme } from '@mui/material';
import {
	primary,
	neutral2,
	neutral3,
	neutral7,
	inputLabels,
} from './styles/colors';

const colors = {
	primary: '#004225',
	secondary: '#00422599',
	white: '#fff',
	black: '#000',
};

const theme = createTheme({
	palette: {
		primary: {
			main: colors.primary,
		},
		secondary: {
			main: colors.secondary,
		},
	},
	components: {
		typography: {
			fontSize: '0.85rem',
			fontFamily: '"Inter", sans-serif',
		},
		MuiButton: {
			styleOverrides: {
				root: {
					fontSize: '0.85rem',
					fontFamily: '"Inter", sans-serif',
					textTransform: 'uppercase', // Set the desired text transform value
					'&:disabled': {
						color: '#909090', // Set the desired disabled color
					},
				},
			},
		},
		MuiTypography: {
			styleOverrides: {
				root: {
					fontSize: '0.85rem',
					fontFamily: '"Inter", sans-serif',
					color: '#212121',
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					border: `1px solid #e7e7e7`,
				},
			},
		},
		MuiSelect: {
			styleOverrides: {
				root: {
					fontSize: '0.85rem',
					fontFamily: '"Inter", sans-serif',
				},
			},
		},
		MuiMenuItem: {
			styleOverrides: {
				root: {
					fontSize: '0.85rem',
					fontFamily: '"Inter", sans-serif',
				},
			},
		},
		MuiFormControlLabel: {
			styleOverrides: {
				root: {
					span: {
						fontSize: inputLabels,
					},
				},
			},
		},
		MuiToggleButtonGroup: {
			styleOverrides: {
				root: {
					width: '100%',
				},
			},
		},
		MuiToggleButton: {
			styleOverrides: {
				root: {
					fontSize: inputLabels,
				},
			},
		},
		MuiDivider: {
			styleOverrides: {
				root: {
					margin: '15px 0 0 0',
					borderBottomWidth: 0,
				},
			},
		},
		MuiCircularProgress: {
			colorPrimary: {
				color: primary,
			},
		},
		MuiDataGrid: {
			styleOverrides: {
				root: {
					border: `2px solid ${neutral2}`,
				},
				withBorderColor: {
					borderColor: neutral3,
				},
				columnHeaders: {
					backgroundColor: neutral2,
					borderBottom: `2px solid`,
				},
				columnHeaderTitle: {
					fontWeight: 'bold',
					color: neutral7,
				},
			},
		},
	},
	overrides: {
		MuiTabs: {
			indicator: {
				backgroundColor: colors.black,
			},
		},
		MuiTab: {
			selected: {
				backgroundColor: colors.black,
			},
		},
	},
});

export default theme;
